import * as pathToRegexp from 'path-to-regexp';
import { App } from '@app/src/views';
import { StepOne } from '@app/src/views/StepOne';
import { StepTwo } from '@app/src/views/StepTwo';
import { StepThree } from '@app/src/views/StepThree';
import { StepPayment } from '@app/src/views/StepPayment';
import { NotFound } from '@app/src/views/NotFound';
import { withStep } from '@app/src/common/withStep';
import { Home } from '@app/src/views/Home';
import { Agency } from '@app/src/views/Agency';
import { TermsConditions } from '@app/src/views/HelpCenter/Legal/TermsConditions';
import { PublishingPolicies } from '@app/src/views/HelpCenter/Legal/PublishingPolicies';
import { PrivacyPolicies } from '@app/src/views/HelpCenter/Legal/PrivacyPolicies';
import { ConsentClause } from '@app/src/views/HelpCenter/Legal/ConsentClause';
import { FrequentQuestions } from '@app/src/views/HelpCenter/FrequentQuestions';
import { StepConfirm } from '@app/src/views/StepConfirm';
import { PaymentPending } from '@app/src/views/PaymentPending';
import { CATEGORY_ALIAS, CATEGORIES } from '@app/src/config/categories';
import { Registration } from '@app/src/views/Registration';
import { Login } from '@app/src/views/Login';
import { MyAccount } from '@app/src/views/MyAccount';
import { RecoveryPassword } from '@app/src/views/RecoveryPassword';
import { Package } from '@app/src/views/Package';
import { AnnouncementCalendar } from '@app/src/views/AnnouncementCalendar';
import { AnnouncementExtracharge } from '@app/src/views/AnnouncementExtracharges';
import { MyPackage } from '@app/src/views/MyPackage';

const pathsProperty = CATEGORIES[CATEGORY_ALIAS.INMUEBLE].paths;
const pathsEmployment = CATEGORIES[CATEGORY_ALIAS.EMPLEO].paths;
const pathsOpportunity = CATEGORIES[CATEGORY_ALIAS.OPORTUNIDAD].paths;
const pathsVehicle = CATEGORIES[CATEGORY_ALIAS.VEHICULO].paths;
const pathsEducation = CATEGORIES[CATEGORY_ALIAS.EDUCACION].paths;

export const Routes = [
  {
    component: App,
    routes: [
      {
        path: '/',
        component: Home,
        exact: true,
        alias: 'home'
      },
      {
        path: '/agencias',
        component: Agency,
        exact: true,
        alias: 'agency'
      },
      {
        path: '/terminos-y-condiciones',
        component: TermsConditions,
        exact: true,
        alias: 'termsConditions'
      },
      {
        path: '/politicas-de-publicacion',
        component: PublishingPolicies,
        exact: true,
        alias: 'publishingPolicies'
      },
      {
        path: '/politicas-de-privacidad',
        component: PrivacyPolicies,
        exact: true,
        alias: 'privacyPolicies'
      },
      {
        path: '/clausula-de-consentimiento-para-fines-adicionales',
        component: ConsentClause,
        exact: true,
        alias: 'consentClause'
      },
      {
        path: '/preguntas-frecuentes',
        component: FrequentQuestions,
        exact: true,
        alias: 'frequentQuestions'
      },
      {
        path: pathsProperty.purchasePrint.stepOne,
        component: withStep(StepOne, { title: 'Compra tu aviso', step: 1 }),
        exact: true,
        alias: 'stepOneProperty'
      },
      {
        path: pathsProperty.purchasePrint.stepTypePublication,
        component: withStep(StepTwo, { title: 'Compra tu aviso', step: 2 }),
        exact: true,
        alias: 'stepTwoProperty'
      },
      {
        path: pathsProperty.purchasePrint.stepCalendar,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2 }),
        exact: true,
        alias: 'stepTwoPropertyCalendar'
      },
      {
        path: pathsProperty.purchasePrint.stepExtracharge,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2 }),
        exact: true,
        alias: 'stepTwoPropertyExtracharge'
      },
      {
        path: `${pathsProperty.purchasePrint.stepSummary}/:idPrint?`,
        component: withStep(StepThree, { title: 'Compra tu aviso', step: 3 }),
        exact: true,
        alias: 'stepThree'
      },
      {
        path: `${pathsProperty.purchasePrint.stepFacturation}/:id?`,
        component: withStep(StepPayment, { title: 'Compra tu aviso', step: 4 }),
        exact: true,
        alias: 'stepPayment'
      },
      {
        path: '/confirmacion-de-pago',
        component: withStep(StepConfirm, { title: 'Confirmación de pago' }),
        exact: true,
        alias: 'paymentConfirm'
      },
      {
        path: '/pendiente-de-pago',
        component: withStep(PaymentPending, { title: 'Pendiente de pago' }),
        exact: true,
        alias: 'paymentPending'
      },
      {
        path: pathsEmployment.purchasePrint.stepOne,
        component: withStep(StepOne, { title: 'Compra tu aviso', step: 1 }),
        exact: true,
        alias: 'stepOneJob'
      },
      {
        path: pathsEmployment.purchasePrint.stepTypePublication,
        component: withStep(StepTwo, { title: 'Compra tu aviso', step: 2 }),
        exact: true,
        alias: 'stepTwoJob'
      },
      {
        path: pathsEmployment.purchasePrint.stepCalendar,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2 }),
        exact: true,
        alias: 'stepTwoJobCalendar'
      },
      {
        path: pathsEmployment.purchasePrint.stepExtracharge,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2 }),
        exact: true,
        alias: 'stepTwoJobExtracharge'
      },
      {
        path: `${pathsEmployment.purchasePrint.stepSummary}/:idPrint?`,
        component: withStep(StepThree, { title: 'Compra tu aviso', step: 3 }),
        exact: true,
        alias: 'stepThreeJob'
      },
      {
        path: `${pathsEmployment.purchasePrint.stepFacturation}/:id?`,
        component: withStep(StepPayment, { title: 'Compra tu aviso', step: 4 }),
        exact: true,
        alias: 'stepPaymentJob'
      },
      {
        path: pathsOpportunity.purchasePrint.stepOne,
        component: withStep(StepOne, { title: 'Compra tu aviso', step: 1 }),
        exact: true,
        alias: 'stepOneOpportunity'
      },
      {
        path: pathsOpportunity.purchasePrint.stepTypePublication,
        component: withStep(StepTwo, { title: 'Compra tu aviso', step: 2 }),
        exact: true,
        alias: 'stepTwoOpportunity'
      },
      {
        path: pathsOpportunity.purchasePrint.stepCalendar,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2 }),
        exact: true,
        alias: 'stepTwoOpportunityCalendar'
      },
      {
        path: pathsOpportunity.purchasePrint.stepExtracharge,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2 }),
        exact: true,
        alias: 'stepTwoOpportunityExtracharge'
      },
      {
        path: `${pathsOpportunity.purchasePrint.stepSummary}/:idPrint?`,
        component: withStep(StepThree, { title: 'Compra tu aviso', step: 3 }),
        exact: true,
        alias: 'stepThreeOpportunity'
      },
      {
        path: `${pathsOpportunity.purchasePrint.stepFacturation}/:id?`,
        component: withStep(StepPayment, { title: 'Compra tu aviso', step: 4 }),
        exact: true,
        alias: 'stepPaymentOpportunity'
      },
      {
        path: pathsVehicle.purchasePrint.stepOne,
        component: withStep(StepOne, { title: 'Compra tu aviso', step: 1 }),
        exact: true,
        alias: 'stepOneVehicle'
      },
      {
        path: pathsVehicle.purchasePrint.stepTypePublication,
        component: withStep(StepTwo, { title: 'Compra tu aviso', step: 2 }),
        exact: true,
        alias: 'stepTwoVehicle'
      },
      {
        path: pathsVehicle.purchasePrint.stepCalendar,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2 }),
        exact: true,
        alias: 'stepTwoVehicleCalendar'
      },
      {
        path: pathsVehicle.purchasePrint.stepExtracharge,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2 }),
        exact: true,
        alias: 'stepTwoVehicleExtracharge'
      },
      {
        path: `${pathsVehicle.purchasePrint.stepSummary}/:idPrint?`,
        component: withStep(StepThree, { title: 'Compra tu aviso', step: 3 }),
        exact: true,
        alias: 'stepThreeVehicle'
      },
      {
        path: `${pathsVehicle.purchasePrint.stepFacturation}/:id?`,
        component: withStep(StepPayment, { title: 'Compra tu aviso', step: 4 }),
        exact: true,
        alias: 'stepPaymentVehicle'
      },
      {
        path: pathsEducation.purchasePrint.stepOne,
        component: withStep(StepOne, { title: 'Compra tu aviso', step: 1 }),
        exact: true,
        alias: 'stepOneEducation'
      },
      {
        path: pathsEducation.purchasePrint.stepTypePublication,
        component: withStep(StepTwo, { title: 'Compra tu aviso', step: 2 }),
        exact: true,
        alias: 'stepTwoEducation'
      },
      {
        path: pathsEducation.purchasePrint.stepCalendar,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2 }),
        exact: true,
        alias: 'stepTwoEducationCalendar'
      },
      {
        path: pathsEducation.purchasePrint.stepExtracharge,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2 }),
        exact: true,
        alias: 'stepTwoEducationExtracharge'
      },
      {
        path: `${pathsEducation.purchasePrint.stepSummary}/:idPrint?`,
        component: withStep(StepThree, { title: 'Compra tu aviso', step: 3 }),
        exact: true,
        alias: 'stepThreeEducation'
      },
      {
        path: `${pathsEducation.purchasePrint.stepFacturation}/:id?`,
        component: withStep(StepPayment, { title: 'Compra tu aviso', step: 4 }),
        exact: true,
        alias: 'stepPaymentEducation'
      },
      {
        path: '/registrate',
        component: Registration,
        exact: true,
        alias: 'registration'
      },
      {
        path: '/inicia-tu-sesion',
        component: Login,
        exact: true,
        alias: 'login'
      },
      {
        path: '/mi-cuenta',
        component: MyAccount,
        exact: true,
        alias: 'myAccount'
      },
      {
        path: '/cambiar-contrasena/:hash?',
        component: RecoveryPassword,
        exact: true,
        alias: 'recoveryPassword'
      },
      {
        path: '/compra-tu-paquete-de-avisos-impreso',
        component: Package,
        exact: true,
        alias: 'package'
      },
      {
        path: pathsProperty.purchasePackage.stepSelection,
        component: Package,
        exact: true,
        alias: 'packageProperty'
      },
      {
        path: pathsEmployment.purchasePackage.stepSelection,
        component: Package,
        exact: true,
        alias: 'packageEmploymentPackage'
      },
      {
        path: pathsOpportunity.purchasePackage.stepSelection,
        component: Package,
        exact: true,
        alias: 'packageOpportunityPackage'
      },
      {
        path: pathsVehicle.purchasePackage.stepSelection,
        component: Package,
        exact: true,
        alias: 'packageVehiclePackage'
      },
      {
        path: pathsEducation.purchasePackage.stepSelection,
        component: Package,
        exact: true,
        alias: 'packageEducationPackage'
      },
      {
        path: `${pathsProperty.purchasePackage.stepFacturation.talan}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepPropertyPaymentPackageTalan'
      },
      {
        path: `${pathsProperty.purchasePackage.stepFacturation.comercioTalan}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepPropertyPaymentPackageComercioTalan'
      },
      {
        path: `${pathsProperty.purchasePackage.stepFacturation.comercio}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepPropertyPaymentPackageComercio'
      },
      {
        path: `${pathsVehicle.purchasePackage.stepFacturation.talan}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepVehiclePaymentPackageTalan'
      },
      {
        path: `${pathsVehicle.purchasePackage.stepFacturation.comercioTalan
          }/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepVehiclePaymentPackageComercioTalan'
      },
      {
        path: `${pathsVehicle.purchasePackage.stepFacturation.comercio}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepVehiclePaymentPackageComercio'
      },
      {
        path: `${pathsEmployment.purchasePackage.stepFacturation.talan}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepEmploymentPaymentPackageTalan'
      },
      {
        path: `${pathsEmployment.purchasePackage.stepFacturation.comercioTalan}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepEmploymentPaymentPackageComercioTalan'
      },
      {
        path: `${pathsEmployment.purchasePackage.stepFacturation.comercio}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepEmploymentPaymentPackageComercio'
      },
      {
        path: `${pathsEducation.purchasePackage.stepFacturation.talan}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepEducationPaymentPackageTalan'
      },
      {
        path: `${pathsEducation.purchasePackage.stepFacturation.comercioTalan}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepEducationPaymentPackageComercioTalan'
      },
      {
        path: `${pathsEducation.purchasePackage.stepFacturation.comercio}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepEducationPaymentPackageComercio'
      },
      {
        path: `${pathsOpportunity.purchasePackage.stepFacturation.talan}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepOpportunityPaymentPackageTalan'
      },
      {
        path: `${pathsOpportunity.purchasePackage.stepFacturation.comercioTalan}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepOpportunityPaymentPackageComercioTalan'
      },
      {
        path: `${pathsOpportunity.purchasePackage.stepFacturation.comercio}/:id`,
        component: withStep(StepPayment, { title: 'Compra de paquete' }),
        exact: true,
        alias: 'stepOpportunityPaymentPackageComercio'
      },
      {
        path: pathsProperty.purchasePackage.stepFacturationConfirm.success.talan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentPropertyPackageConfirmTalan'
      },
      {
        path: pathsProperty.purchasePackage.stepFacturationConfirm.success.comercioTalan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentPropertyPackageConfirmComercioTalan'
      },
      {
        path: pathsProperty.purchasePackage.stepFacturationConfirm.success.comercio,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentPropertyPackageConfirmComercio'
      },
      {
        path: pathsVehicle.purchasePackage.stepFacturationConfirm.success.talan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentVehiclePackageConfirmTalan'
      },
      {
        path: pathsVehicle.purchasePackage.stepFacturationConfirm.success.comercioTalan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentVehiclePackageConfirmComercioTalan'
      },
      {
        path: pathsVehicle.purchasePackage.stepFacturationConfirm.success.comercio,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentVehiclePackageConfirmComercio'
      },
      {
        path: pathsEmployment.purchasePackage.stepFacturationConfirm.success.talan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentEmploymentPackageConfirmTalan'
      },
      {
        path: pathsEmployment.purchasePackage.stepFacturationConfirm.success.comercioTalan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentEmploymentPackageConfirmComercioTalan'
      },
      {
        path: pathsEmployment.purchasePackage.stepFacturationConfirm.success.comercio,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentEmploymentPackageConfirmComercio'
      },
      {
        path: pathsEducation.purchasePackage.stepFacturationConfirm.success.talan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentEducationPackageConfirmTalan'
      },
      {
        path: pathsEducation.purchasePackage.stepFacturationConfirm.success.comercioTalan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentEducationPackageConfirmComercioTalan'
      },
      {
        path: pathsEducation.purchasePackage.stepFacturationConfirm.success.comercio,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentEducationPackageConfirmComercio'
      },
      {
        path: pathsOpportunity.purchasePackage.stepFacturationConfirm.success.talan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentOpportunityPackageConfirmTalan'
      },
      {
        path: pathsOpportunity.purchasePackage.stepFacturationConfirm.success.comercioTalan,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentOpportunityPackageConfirmComercioTalan'
      },
      {
        path: pathsOpportunity.purchasePackage.stepFacturationConfirm.success.comercio,
        component: withStep(StepConfirm, { title: 'Confirmación de compra' }),
        exact: true,
        alias: 'paymentOpportunityPackageConfirmComercio'
      },
      {
        path: pathsProperty.purchasePackage.stepFacturationConfirm.pending.talan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentPropertyPackagePendingTalan'
      },
      {
        path: pathsProperty.purchasePackage.stepFacturationConfirm.pending.comercioTalan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentPropertyPackagePendingComercioTalan'
      },
      {
        path: pathsProperty.purchasePackage.stepFacturationConfirm.pending.comercio,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentPropertyPackagePendingComercio'
      },
      {
        path: pathsVehicle.purchasePackage.stepFacturationConfirm.pending.talan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentVehiclePackagePendingTalan'
      },
      {
        path: pathsVehicle.purchasePackage.stepFacturationConfirm.pending.comercioTalan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentVehiclePackagePendingComercioTalan'
      },
      {
        path: pathsVehicle.purchasePackage.stepFacturationConfirm.pending.comercio,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentVehiclePackagePendingComercio'
      },
      {
        path: pathsEmployment.purchasePackage.stepFacturationConfirm.pending.talan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentEmploymentPackagePendingTalan'
      },
      {
        path: pathsEmployment.purchasePackage.stepFacturationConfirm.pending.comercioTalan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentEmploymentPackagePendingComercioTalan'
      },
      {
        path: pathsEmployment.purchasePackage.stepFacturationConfirm.pending.comercio,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentEmploymentPackagePendingComercio'
      },
      {
        path: pathsEducation.purchasePackage.stepFacturationConfirm.pending.talan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentEducationPackagePendingTalan'
      },
      {
        path: pathsEducation.purchasePackage.stepFacturationConfirm.pending.comercioTalan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentEducationPackagePendingComercioTalan'
      },
      {
        path: pathsEducation.purchasePackage.stepFacturationConfirm.pending.comercio,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentEducationPackagePendingComercio'
      },
      {
        path: pathsOpportunity.purchasePackage.stepFacturationConfirm.pending.talan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentOpportunityPackagePendingTalan'
      },
      {
        path: pathsOpportunity.purchasePackage.stepFacturationConfirm.pending.comercioTalan,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentOpportunityPackagePendingComercioTalan'
      },
      {
        path: pathsOpportunity.purchasePackage.stepFacturationConfirm.pending.comercio,
        component: withStep(PaymentPending, { title: 'Pendiente de compra' }),
        exact: true,
        alias: 'paymentOpportunityPackagePendingComercio'
      },
      {
        path: `${pathsProperty.consumePackage.stepOne}/:packageId?/:uniqueId?`,
        component: withStep(StepOne, { title: 'Crea tu aviso', step: 1, announcementAvailable: true }),
        exact: true,
        alias: 'stepOnePropertyConsumePackageForEdit'
      },
      {
        path: `${pathsProperty.consumePackage.stepTypePublication}/:packageId?`,
        component: withStep(StepTwo, { title: 'Crea tu aviso', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoPropertyConsumePackage'
      },
      {
        path: `${pathsProperty.consumePackage.stepCalendar}/:packageId?`,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoPropertyConsumePackageCalendar'
      },
      {
        path: `${pathsProperty.consumePackage.stepExtracharge}/:packageId?`,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoPropertyConsumePackageExtracharge'
      },
      {
        path: `${pathsProperty.consumePackage.stepSummary}/:packageId?/:idPrint?`,
        component: withStep(StepThree, { title: 'Crea tu aviso', step: 3, announcementAvailable: true }),
        exact: true,
        alias: 'stepThreePropertyConsumePackageSummary'
      },
      {
        path: pathsProperty.consumePackage.stepPrintPublished,
        component: withStep(StepConfirm, { title: 'Confirmación de publicación', announcementAvailable: true }),
        exact: true,
        alias: 'stepConfirmPublicationPropertyConsumePackage'
      },
      {
        path: `${pathsVehicle.consumePackage.stepOne}/:packageId?/:uniqueId?`,
        component: withStep(StepOne, { title: 'Crea tu aviso', step: 1, announcementAvailable: true }),
        exact: true,
        alias: 'stepOneVehicleConsumePackage'
      },
      {
        path: `${pathsVehicle.consumePackage.stepTypePublication}/:packageId?`,
        component: withStep(StepTwo, { title: 'Crea tu aviso', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoVehicleConsumePackage'
      },
      {
        path: `${pathsVehicle.consumePackage.stepCalendar}/:packageId?`,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoVehicleConsumePackageCalendar'
      },
      {
        path: `${pathsVehicle.consumePackage.stepExtracharge}/:packageId?`,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoVehicleConsumePackageExtracharge'
      },
      {
        path: `${pathsVehicle.consumePackage.stepSummary}/:packageId?/:idPrint?`,
        component: withStep(StepThree, { title: 'Crea tu aviso', step: 3, announcementAvailable: true }),
        exact: true,
        alias: 'stepThreeVehicleConsumePackageSummary'
      },
      {
        path: pathsVehicle.consumePackage.stepPrintPublished,
        component: withStep(StepConfirm, { title: 'Confirmación de publicación', announcementAvailable: true }),
        exact: true,
        alias: 'stepConfirmPublicationVehicleConsumePackage'
      },
      {
        path: `${pathsEmployment.consumePackage.stepOne}/:packageId?/:uniqueId?`,
        component: withStep(StepOne, { title: 'Crea tu aviso', step: 1, announcementAvailable: true }),
        exact: true,
        alias: 'stepOneEmploymentConsumePackage'
      },
      {
        path: `${pathsEmployment.consumePackage.stepTypePublication}/:packageId?`,
        component: withStep(StepTwo, { title: 'Crea tu aviso', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoEmploymentConsumePackage'
      },
      {
        path: `${pathsEmployment.consumePackage.stepCalendar}/:packageId?`,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoEmploymentConsumePackageCalendar'
      },
      {
        path: `${pathsEmployment.consumePackage.stepExtracharge}/:packageId?`,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoEmploymentConsumePackageExtracharge'
      },
      {
        path: `${pathsEmployment.consumePackage.stepSummary}/:packageId/:idPrint?`,
        component: withStep(StepThree, { title: 'Crea tu aviso', step: 3, announcementAvailable: true }),
        exact: true,
        alias: 'stepThreeEmploymentConsumePackageSummary'
      },
      {
        path: pathsEmployment.consumePackage.stepPrintPublished,
        component: withStep(StepConfirm, { title: 'Confirmación de publicación', announcementAvailable: true }),
        exact: true,
        alias: 'stepConfirmPublicationEmploymentConsumePackage'
      },
      {
        path: `${pathsEducation.consumePackage.stepOne}/:packageId?/:uniqueId?`,
        component: withStep(StepOne, { title: 'Crea tu aviso', step: 1, announcementAvailable: true }),
        exact: true,
        alias: 'stepOneEducationConsumePackage'
      },
      {
        path: `${pathsEducation.consumePackage.stepTypePublication}/:packageId?`,
        component: withStep(StepTwo, { title: 'Crea tu aviso', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoEducationConsumePackage'
      },
      {
        path: `${pathsEducation.consumePackage.stepCalendar}/:packageId?`,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoEducationConsumePackageCalendar'
      },
      {
        path: `${pathsEducation.consumePackage.stepExtracharge}/:packageId?`,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoEducationConsumePackageExtracharge'
      },
      {
        path: `${pathsEducation.consumePackage.stepSummary}/:packageId?/:idPrint?`,
        component: withStep(StepThree, { title: 'Crea tu aviso', step: 3, announcementAvailable: true }),
        exact: true,
        alias: 'stepThreeEducationConsumePackageSummary'
      },
      {
        path: pathsEducation.consumePackage.stepPrintPublished,
        component: withStep(StepConfirm, { title: 'Confirmación de publicación', announcementAvailable: true }),
        exact: true,
        alias: 'stepConfirmPublicationEducationConsumePackage'
      },
      {
        path: `${pathsOpportunity.consumePackage.stepOne}/:packageId?/:uniqueId?`,
        component: withStep(StepOne, { title: 'Crea tu aviso', step: 1, announcementAvailable: true }),
        exact: true,
        alias: 'stepOneOpportunityConsumePackage'
      },
      {
        path: `${pathsOpportunity.consumePackage.stepTypePublication}/:packageId?`,
        component: withStep(StepTwo, { title: 'Crea tu aviso', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoOpportunityConsumePackage'
      },
      {
        path: `${pathsOpportunity.consumePackage.stepCalendar}/:packageId?`,
        component: withStep(AnnouncementCalendar, { title: 'Calendario', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoOpportunityConsumePackageCalendar'
      },
      {
        path: `${pathsOpportunity.consumePackage.stepExtracharge}/:packageId?`,
        component: withStep(AnnouncementExtracharge, { title: 'Extracargo', step: 2, announcementAvailable: true }),
        exact: true,
        alias: 'stepTwoOpportunityConsumePackageExtracharge'
      },
      {
        path: `${pathsOpportunity.consumePackage.stepSummary}/:packageId?/:idPrint?`,
        component: withStep(StepThree, { title: 'Crea tu aviso', step: 3, announcementAvailable: true }),
        exact: true,
        alias: 'stepThreeOpportunityConsumePackageSummary'
      },
      {
        path: pathsOpportunity.consumePackage.stepPrintPublished,
        component: withStep(StepConfirm, { title: 'Confirmación de publicación', announcementAvailable: true }),
        exact: true,
        alias: 'stepConfirmPublicationOpportunityConsumePackage'
      },
      //My Package
      {
        path: '/mi-cuenta/listado-paquetes/:categoryId?/:uniqueId?',
        component: MyPackage,
        exact: true,
        alias: 'myPackages'
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
];

export const AliasRouter = (alias: string, params: {} = {}): string => {
  let routes = Routes[0].routes;
  for (let k in routes) {
    if (routes[k].alias === alias) {
      let toPath = pathToRegexp.compile(routes[k].path);
      return toPath(params);
    }
  }
  return '';
}
